<template>
    <app-layout title="Aanvragen">
        <template #header>
            <page-title title="Zoeken" />
        </template>

        <template #pageContent>
            <TwoColumns>
                <template #left>
                    <h2>Filter</h2>
                    <Form @submitted="postForm" class="w-full">
                        <Input
                            label="Referentie"
                            name="reference"
                            v-model="form.reference"
                            :error="form.errors.reference"
                            layout="vertical"
                        />
                        <Input
                            label="Factuurnummer"
                            name="invoice_number"
                            v-model="form.invoice_number"
                            :error="form.errors.invoice_number"
                            layout="vertical"
                        />
                        <Input
                            label="Klant"
                            name="customer"
                            v-model="form.customer"
                            :error="form.errors.customer"
                            layout="vertical"
                        />
                        <Select
                            label="Type"
                            name="request_type_id"
                            :options="requestTypeOptions"
                            :emptyOption="true"
                            :sortByLabel="false"
                            v-model="form.request_type_id"
                            :error="form.errors.request_type_id"
                            layout="vertical"
                        />
                        <Input
                            label="Dossiernummer"
                            name="external_reference"
                            v-model="form.external_reference"
                            :error="form.errors.external_reference"
                            layout="vertical"
                            v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop Dewaele')"
                        />
                        <Input
                            type="number"
                            label="Webshop id"
                            name="webshop_id"
                            v-model="form.webshop_id"
                            :error="form.errors.webshop_id"
                            layout="vertical"
                            v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')"
                        />
                        <Select
                            label="Bestek"
                            name="estimate_id"
                            :options="estimateOptions"
                            :emptyOption="true"
                            v-model="form.estimate_id"
                            :error="form.errors.estimate_id"
                            layout="vertical"
                            v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Bestek')"
                        />
                        <Select
                            label="Opdracht"
                            name="assignment_type_id"
                            :options="assignmentTypeOptions"
                            :emptyOption="true"
                            v-model="form.assignment_type_id"
                            :error="form.errors.assignment_type_id"
                            layout="vertical"
                        />
                        <Select
                            label="Status aanvraag"
                            name="status"
                            :options="statusOptions"
                            :emptyOption="true"
                            v-model="form.status"
                            :error="form.errors.status"
                            layout="vertical"
                        />
                        <Input
                            label="Aangevraagd van"
                            name="requested_from"
                            type="date"
                            placeholder="dd-mm-jjjj"
                            v-model="form.requested_from"
                            :error="form.errors.requested_from"
                            layout="vertical"
                        />
                        <Input
                            label="Aangevraagd tot"
                            name="requested_until"
                            type="date"
                            placeholder="dd-mm-jjjj"
                            v-model="form.requested_until"
                            :error="form.errors.requested_until"
                            layout="vertical"
                        />
                        <Input
                            label="Duedate"
                            name="duedate"
                            type="date"
                            placeholder="dd-mm-jjjj"
                            v-model="form.duedate"
                            :error="form.errors.duedate"
                            layout="vertical"
                        />
                        <Input
                            type="text"
                            label="Inspectie straat + nr"
                            name="inspection_address"
                            v-model="form.inspection_address"
                            :error="form.errors.inspection_address"
                            layout="vertical"
                        />
                        <Input
                            type="number"
                            label="Inspectie postcode"
                            name="inspection_postal_code"
                            v-model="form.inspection_postal_code"
                            :error="form.errors.inspection_postal_code"
                            layout="vertical"
                        />
                        <Input
                            type="text"
                            label="Inspectie plaats"
                            name="inspection_place"
                            v-model="form.inspection_place"
                            :error="form.errors.inspection_place"
                            layout="vertical"
                        />

                        <Button text="Aanvragen zoeken" buttonType="submit" buttonClass="filter" :loading="form.processing" class="self-end" />
                    </Form>
                </template>

                <template #right>
                    <template v-if="requests && requests.length > 0">
                        <Table id="requests-search" :values="requests" class="mt-4 w-full" :pageSize="pageSize">
                            <thead>
                                <tr>
                                    <Th id="reference">Referentie</Th>
                                    <Th id="invoice.number">Factuurnr.</Th>
                                    <Th id="customer">Klant</Th>
                                    <Th id="request_type_id">Type</Th>
                                    <Th id="status">Status</Th>
                                    <Th id="requested_at">Aangevraagd op</Th>
                                    <Th :sort="false">Duedate / nieuwe duedate</Th>
                                    <Th id="external_reference">Dossiernr.</Th>
                                    <Th id="webshop_id">Webshop id</Th>
                                    <Th :sort="false">Inspectie adres</Th>
                                    <Th :sort="false"></Th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="request in state.sortedValues['requests-search']" :key="request.id">
                                    <Td>{{ request.reference }}</Td>
                                    <Td>
                                        <template v-if="request.invoice">
                                            {{ request.invoice.number }}
                                        </template>
                                    </Td>
                                    <Td>{{ request.customer }}</Td>
                                    <Td>{{ requestTypeOptions[ request.request_type_id] }}</Td>
                                    <Td>{{ statusses[request.status] }}</Td>
                                    <Td>
                                        <template v-if="request.requested_at">
                                            {{ moment(request.requested_at).format('DD-MM-YYYY') }}
                                        </template>
                                    </Td>
                                    <Td>
                                        <template v-if="request.report && request.report.duedate && request.report.new_duedate === null">
                                            {{ (request.report && request.report.duedate) ? moment(request.report.duedate).format('DD-MM-YYYY') : '' }}
                                        </template>
                                        <template v-else-if="request.report && request.report.new_duedate !== null">
                                            {{ (request.report && request.report.new_duedate) ? moment(request.report.new_duedate).format('DD-MM-YYYY') : '' }}
                                        </template>
                                    </Td>
                                    <Td>{{ request.external_reference }}</Td>
                                    <Td>{{ request.webshop_id }}</Td>
                                    <Td>
                                        {{ request.inspection_address.name }}<br>
                                        {{ request.inspection_address.address }}<br>
                                        {{ request.inspection_address.postal_code }}<span v-if="request.inspection_address.postal_code">&nbsp;</span>{{ request.inspection_address.place }}
                                    </Td>
                                    <Td>
                                        <Button
                                            htmlType="a"
                                            buttonClass="show"
                                            size="small"
                                            title="Details"
                                            :href="route('requests.detail',  {'id': request.id})"
                                        />
                                    </Td>
                                </tr>
                            </tbody>
                        </Table>
                    </template>
                    <template v-else-if="requests && requests.length === 0">
                        Er zijn geen aanvragen gevonden.
                    </template>
                </template>
            </TwoColumns>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TwoColumns from '@/Components/TwoColumns.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import { useForm } from '@inertiajs/inertia-vue3'
import moment from "moment";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TwoColumns,
        Form,
        Input,
        Select,
    },
    props: [
        'requests',
        'requestTypes',
        'assignmentTypes',
        'estimates',
        'requestStatusses',
        'statusses',
        'pageSize',
    ],
    setup (props)
    {
        let requestTypeOptions = {}
        let assignmentTypeOptions = {}
        let estimateOptions = {}
        let statusOptions = {}

        props.requestTypes.forEach(function(requestType) {
            requestTypeOptions[requestType.id] = requestType.type
        })

        props.assignmentTypes.forEach(function(assignmentType) {
            assignmentTypeOptions[assignmentType.id] = assignmentType.name
        })

        props.estimates.forEach(function(estimate) {
            estimateOptions[estimate.id] = estimate.name
        })

        Object.values(props.requestStatusses).forEach(function(status) {
            statusOptions[status] = props.statusses[status]
        })

        const form = useForm({
            reference: null,
            invoice_number: null,
            customer: null,
            status: null,
            external_reference: null,
            webshop_id: null,
            assignment_type_id: null,
            request_type_id: null,
            estimate_id: null,
            duedate: null,
            requested_from: null,
            requested_until: null,
            inspection_address: null,
            inspection_postal_code: null,
            inspection_place: null,
        })

        function postForm()
        {
            form.post(route('requests.search-filter'),
                {
                    'only': ['requests']
                }
            )
        }

        return {
            state: store.state,
            ...store,
            requestTypeOptions,
            assignmentTypeOptions,
            estimateOptions,
            statusOptions,
            form,
            postForm,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
